export default __webpack_public_path__ + "media/images/57-7e48ee1c43a1e0cdc80211a4f8c40418.png";